<template>
    <div>
      <div class="head">
        <div class="my-contact flex-aic">
            <div class="mail item">
                <div class="icon">
                    <img src="../img/mail.png" alt="">
                </div>
                <p>{{ us_mail }}</p>
            </div>
            <div class="phone item">
                <div class="icon">
                    <img src="../img/phone.png" alt="">
                </div>
                <p>{{ us_phone }}</p>
            </div>
        </div>
        <div class="my-head">
            <div class="container flex-aic">
                <div class="logo">
                    <h2 class="mingzi">{{ company_name }}</h2>
                </div>
                <div class="tab flex-aic">
                    <div class="item">
                        <router-link to="/index"
                            style="color:#fff; text-decoration: none;font-size: 20px; transition: all 0.3s;">首页</router-link>
                    </div>
                    <div class="item">
                        <router-link to="/about"
                            style="color:#fff; text-decoration: none;font-size: 20px; transition: all 0.3s">关于我们</router-link>
                    </div>
                    <div class="item">
                        <router-link to="/product"
                            style="color:#fff; text-decoration: none;font-size: 20px; transition: all 0.3s ">产品与服务</router-link>
                    </div>
                    <div class="item">
                        <router-link to="/news"
                            style="color:#fff; text-decoration: none;font-size: 20px; transition: all 0.3s ">新闻中心</router-link>
                    </div>
                    <div class="item">
                        <router-link to="/contact"
                            style="color:#fff; text-decoration: none;font-size: 20px; transition: all 0.3s ">联系我们</router-link>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <!-- <HeadCommon></HeadCommon> -->
      <div class="main">
        <div class="head_bg">
            <img src="../img/contact_us-bg.png" alt="">
            <div class="text">
                <p style="color: #fff;">列表详情</p>
                <span></span>
            </div>
        </div>
        <div class="container">
            <div class="info">
                <div class="tab" style="margin-top: 25px;">
                    当前位置:
                    <router-link to="/product">>产品与服务
                    </router-link>
                    
                    <router-link to="/listdetails">
                    <a class="active">>产品与服务列表详情</a>
                    </router-link>
                </div>
                <div class="article">
                    <h2>{{title}}</h2>
                    <h5>发布时间: {{ create_time }}</h5>
                    <div class="text" style="margin-bottom: 100px;">
                        <p v-html="article"></p>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <FootCommon></FootCommon>
    </div>
</template>
<script>
    import FootCommon from '@/components/FootCommon.vue';
    import { getIndustryListInfo } from "@/api/product";
    import { addressList } from "@/api/index";
    // import store from "@/store/index";
    export default {
        name:'ListDetails',
        components: {
      FootCommon
    },
    data() {
        return {
            title:'',
            create_time:'',
            article:'',
            img:'',
            us_phone: '',
            us_mail: '',
            company_name: '',
        }
    },
    created() {
        // const pageId = store.state.pageId; // 获取 Vuex store 中的 pageId
        this.addressList()
        this.getIndustryListInfo(); // 将 pageId 传递给 getnewsinfoList 函数
    },
    methods:{
         // 新闻详情
         async getIndustryListInfo() {
            const pageId = this.$route.params.id; // 从路由参数中获取ID
            console.log(pageId, 88888);
            const {data} = await getIndustryListInfo(pageId)
            console.log(data,'详情');
            this.title= data.title
            this.create_time = data.create_time
            this.article = data.article
            this.img = data.img
        },
        async addressList() {
            const { data } = await addressList()
            console.log(data,456666);
            this.company_name = data.company_name
            this.us_phone = data.us_phone
            this.us_mail = data.us_mail
        },
    },
    }
</script>
<style>
@import '../style/common.css';
@import '../style/basic.css'
</style>
